import React, { createContext, useState, useContext, useEffect } from 'react';

const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
    const [network, setNetwork] = useState(localStorage.getItem('network'));
    const [walletAddress, setWalletAddress] = useState(localStorage.getItem('walletAddress'));

    useEffect(() => {
        if (network) {
            localStorage.setItem('network', network);
        } else {
            localStorage.removeItem('network');
        }
    }, [network]);

    useEffect(() => {
        if (walletAddress) {
            localStorage.setItem('walletAddress', walletAddress);
        } else {
            localStorage.removeItem('walletAddress');
        }
    }, [walletAddress]);

    return (
        <NetworkContext.Provider value={{ network, setNetwork, walletAddress, setWalletAddress }}>
            {children}
        </NetworkContext.Provider>
    );
};

export const useNetwork = () => {
    return useContext(NetworkContext);
};
